import type {
  UpdateInvoicesAdditionalDetailsRequestPayload,
  UpdateInvoicesAdditionalDetailsResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

export function useBulkUpdateInvoiceAdditionalDetails(
  options?: UseMutationOptions<
    UpdateInvoicesAdditionalDetailsResponse,
    unknown,
    UpdateInvoicesAdditionalDetailsRequestPayload
  >,
) {
  const queryClient = useQueryClient();

  return useMutation(
    (updateInvoicesAdditionalDetailsRequest) => {
      const api = getPrivateApi();

      return api.updateInvoicesAdditionalDetails({
        updateInvoicesAdditionalDetailsRequest,
      });
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await invalidateInvoicesQueries(queryClient);
        await options?.onSuccess?.(data, variables, context);
      },
    },
  );
}
